module.exports = __webpack_public_path__ + "common/icon-app-apparel-71f8f07fd83e308bdcf83056e472b3ca.svg";